
import { application } from "./application";
import ClipboardController from "./clipboard_controller.js";
import DragController from "./drag_controller.js";
import EmptyStateController from "./empty_state_controller.js";
import FormController from "./form_controller.js";
import InfiniteScrollController from "./infinite_scroll_controller.js";
import ModalController from "./modal_controller.js";
import PlaceholdersController from "./placeholders_controller.js";
import RichtextController from "./richtext_controller.js";
import SelectizeController from "./selectize_controller.js";
import WhatsappController from "./whatsapp_controller.js";

application.register("clipboard", ClipboardController);
application.register("drap", DragController);
application.register("empty-state", EmptyStateController);
application.register("form", FormController);
application.register("infinite-scroll", InfiniteScrollController);
application.register("modal", ModalController);
application.register("placeholder", PlaceholdersController);
application.register("richtest", RichtextController);
application.register("selectize", SelectizeController);
application.register("whatsapp", WhatsappController);